/**
 * WordPress dependencies
 */
import { store, getContext } from '@wordpress/interactivity';

const { state, actions, callbacks } = store( 'eventsGrid', {
	state: {
		page: 1,
		isLoading: false,
	},
	actions: {
		get_events: async () => {
			if ( state.isLoading ) return;
			state.isLoading = true;

			const wrapper = document.getElementById('results-holder');

			await fetch('/wp-json/events-grid/v1/get-events', {
				 method: 'POST',
				 credentials: 'same-origin',
				 headers: {
					 'Cache-Control': 'no-cache',
					 'X-WP-Nonce': document.getElementById('events-grid').dataset.nonce
				 },
				 body: new URLSearchParams({
					 page: state.page
				 })
			})
				.then(response => response.json())
				.then(response => {
					state.isLoading = false;
					wrapper.innerHTML = response.data;

					const next_page = document.getElementById('next-page');
					const prev_page = document.getElementById('prev-page');

					if (next_page) {
						next_page.addEventListener("click", (e) => {
							state.page = state.page + 1;
							wrapper.scrollIntoView({behavior: 'smooth'});
							actions.get_events();
						});
					}

					if (prev_page) {
						prev_page.addEventListener("click", (e) => {
							state.page = state.page - 1;
							wrapper.scrollIntoView({behavior: 'smooth'});
							actions.get_events();
						});
					}

					const current_page = document.querySelectorAll('a.current-page');

					[...current_page].forEach(item => {
						item.addEventListener("click", (e) => {
							wrapper.scrollIntoView({behavior: 'smooth'});
							state.page = parseInt(e.target.getAttribute('data-page'));
							actions.get_events();
						});
					});
				})
				.catch(err => {
					state.isLoading = false;
					console.log(err);
				});
		},
		removeExtraHandlers: (array) => {
			[...array].forEach(item => {
				item.removeEventListener("click", (e) => {
					wrapper.scrollIntoView({behavior: 'smooth'});
					//context.page = parseInt(e.target.getAttribute('data-page'));
					state.page = parseInt(e.target.getAttribute('data-page'));
					//actions.get_listings();
				});
			});
		},
		removeExtraHandlersNext(next_page) {
			next_page.removeEventListener("click", (e) => {
				//context.page = context.page + 1;
				state.page = state.page + 1;
				wrapper.scrollIntoView({behavior: 'smooth'});
			});
		},
		removeExtraHandlersPrev(prev_page) {
			prev_page.removeEventListener("click", (e) => {
				//context.page = context.page + 1;
				state.page = state.page + 1;
				wrapper.scrollIntoView({behavior: 'smooth'});
			});
		},
	},
	callbacks: {
		initEventsGrid: () => {
			actions.get_events();
		},
	},
} );
